import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import handleCSRF from "../../../config/CSRF";

function AddMainCategoryForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [formData, setFormData] = useState({
    category_name: "",
    cat_name_arabic: "",
    description: "",
    web_status: "active",
    subscriptions_status: "active",
    status: "active",
    is_subscription: 1,
    is_sub_cat: 0,
  });
  const [loading, setLoading] = useState(false);
  const [catImage, setCatImg] = useState(null);
  const [catBanner, setCatBanner] = useState(null);
  const chooseOptions = [
    { label: "No", value: 0 },
    { label: "Yes", value: 1 },
  ];
  const [selectBanner, setSelectBanner] = useState("No file chosen");
  const [selectIcon, setSelectIcon] = useState("No file chosen");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    let formDataToSend = new FormData();

    formDataToSend.append("category_name", formData.category_name);
    formDataToSend.append("cat_name_arabic", formData.cat_name_arabic);
    formDataToSend.append("description", formData.description);
    if (catImage) formDataToSend.append("cat_image", catImage);
    if (catBanner) formDataToSend.append("cat_banner", catBanner);
    formDataToSend.append("web_status", formData.web_status);
    formDataToSend.append(
      "subscriptions_status",
      formData.subscriptions_status
    );
    formDataToSend.append("status", formData.status);
    formDataToSend.append("is_subscription", formData.is_subscription);
    formDataToSend.append("is_priority", 0);
    formDataToSend.append("user_id", user?.user.id);
    formDataToSend.append("outlet_id", user?.user.outlet_id);
    formDataToSend.append("is_sub_cat", formData.is_sub_cat);

    const postData = (csrfToken) => {
      if (!id) {
        axios
          .post(`${apiKey}/api/rms/admin/categories`, formDataToSend, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            toast.error(err.response.data.message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
          .finally(() => setLoading(false));
      } else {
        axios
          .post(
            `${apiKey}/api/rms/admin/categories/${id}?_method=PUT`,
            formDataToSend,
            {
              headers: {
                Authorization: `Bearer ${user?.token}`,
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            toast.error(err.response.data.message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
          .finally(() => setLoading(false));
      }
    };
    handleCSRF(postData);
  };

  useEffect(() => {
    if (id) {
      axios
        .get(`${apiKey}/api/rms/admin/categories/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setFormData(res.data);
        })
        .catch((err) => {});
    }
  }, [id, user?.token]);

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl">Add Main Category</h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Category Name
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Category Name"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="category_name"
                    value={formData.category_name}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Description
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Description"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Category Name Arabic
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Category Name Arabic"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="cat_name_arabic"
                    value={formData.cat_name_arabic}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className="flex flex-col lg:flex-row gap-x-8 gap-y-2 w-full items-center">
              <label htmlFor="" className="w-full lg:w-1/3">
                <span className="text-[#7B20C7] text-sm mb-2 relative ">
                  Sub Category ?
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    placeholder="Select"
                    options={chooseOptions}
                    value={{
                      value: formData.is_sub_cat,
                      label: formData.is_sub_cat === 0 ? "No" : "Yes",
                    }}
                    onChange={(e) =>
                      setFormData({ ...formData, is_sub_cat: e.value })
                    }
                  />
                </div>
              </label>

              <div htmlFor="" className="w-full lg:w-1/3 pt-5">
                <div className="flex flex-row items-center">
                  <input
                    type="file"
                    id="icon-input"
                    accept="image/*"
                    onChange={(e) => {
                      setSelectIcon(e.target.files[0].name);
                      setCatImg(e.target.files[0]);
                    }}
                    hidden
                  />
                  <label
                    for="icon-input"
                    className="block text-sm text-white mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-[#7B20C7] cursor-pointer"
                  >
                    Choose icon
                  </label>
                  <label className="text-sm text-slate-500">{selectIcon}</label>
                </div>
              </div>

              <div htmlFor="" className="w-full lg:w-1/3 pt-5">
                <div className="flex flex-row items-center">
                  <input
                    type="file"
                    id="banner-input"
                    accept="image/*"
                    onChange={(e) => {
                      setSelectBanner(e.target.files[0].name);
                      setCatBanner(e.target.files[0]);
                    }}
                    hidden
                  />
                  <label
                    for="banner-input"
                    className="block text-sm text-white mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-[#7B20C7] cursor-pointer"
                  >
                    Choose Banner
                  </label>
                  <label className="text-sm text-slate-500">{selectBanner}</label>
                </div>
              </div>
            </div>

            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddMainCategoryForm;
